import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiPhone, FiLock, FiUserPlus, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';

const RegisterWithInvitation = () => {
  const { code } = useParams();
  const [formData, setFormData] = useState({
    phone: '',
    password: '',
    confirmPassword: '',
    invitationCode: code || ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const [invitationValid, setInvitationValid] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    verifyInvitation();
  }, [code]);

  const verifyInvitation = async () => {
    try {
      const response = await fetch(`/api/auth/verify-invitation/${code}`);
      const data = await response.json();
      
      if (data.valid) {
        setInvitationValid(true);
      } else {
        setError('邀请码无效或已过期');
        setInvitationValid(false);
      }
    } catch (err) {
      setError('验证邀请码时出错，请稍后重试');
      setInvitationValid(false);
    } finally {
      setVerifying(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('密码不匹配');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('密码至少需要6个字符');
      setLoading(false);
      return;
    }

    try {
      await register({
        phone: formData.phone,
        password: formData.password,
        invitationCode: formData.invitationCode
      });
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || '注册失败，请重试。');
    } finally {
      setLoading(false);
    }
  };

  if (verifying) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f8f9fa', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center' 
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '1.2rem', color: '#1a2b4c' }}>验证邀请码中...</div>
        </div>
      </div>
    );
  }

  if (!invitationValid) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f8f9fa', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding: '20px'
      }}>
        <div style={{ 
          maxWidth: '400px', 
          backgroundColor: 'white', 
          borderRadius: '16px', 
          padding: '40px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
        }}>
          <FiAlertCircle style={{ fontSize: '3rem', color: '#dc3545', marginBottom: '1rem' }} />
          <h1 style={{ color: '#1a2b4c', marginBottom: '1rem', fontSize: '1.5rem' }}>邀请码无效</h1>
          <p style={{ color: '#6c757d', marginBottom: '2rem' }}>
            {error || '这个邀请码可能已过期或已被使用。'}
          </p>
          <Link 
            to="/" 
            style={{ 
              backgroundColor: '#1976d2',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              display: 'inline-block',
              transition: 'background-color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', color: '#1a2b4c' }}>
      {/* 导航栏 */}
      <nav style={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 1000, 
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        backdropFilter: 'blur(10px)',
        padding: '1rem 0',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }}>
        <div className="container">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            maxWidth: '1600px',
            margin: '0 auto'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '1rem',
              textDecoration: 'none',
              color: '#1a2b4c'
            }}>
              <img 
                src="/logo.png" 
                alt="123wonder英文科普" 
                style={{ 
                  height: '50px', 
                  width: 'auto'
                }} 
              />
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <Link to="/" style={{ 
                color: '#1a2b4c', 
                textDecoration: 'none',
                fontWeight: '500',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                transition: 'all 0.3s ease'
              }}>
                首页
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '80vh',
        padding: '40px 20px'
      }}>
        <div style={{ 
          width: '100%', 
          maxWidth: '400px',
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ 
              backgroundColor: 'rgba(40, 167, 69, 0.1)',
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <FiCheckCircle style={{ fontSize: '2rem', color: '#28a745' }} />
            </div>
            <h1 style={{ 
              marginBottom: '8px', 
              color: '#1a2b4c',
              fontSize: '1.5rem',
              fontWeight: '700'
            }}>
              欢迎
            </h1>
            <p style={{ 
              color: '#6c757d',
              fontSize: '1rem'
            }}>
              请完成您的账号注册
            </p>
          </div>

          {error && (
            <div style={{ 
              padding: '12px 16px',
              marginBottom: '24px',
              borderRadius: '8px',
              backgroundColor: '#f8d7da',
              color: '#721c24',
              border: '1px solid #f5c6cb'
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px',
                color: '#495057',
                fontWeight: '500'
              }}>
                手机号
              </label>
              <div style={{ position: 'relative' }}>
                <FiPhone style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
                <input
                  type="tel"
                  name="phone"
                  style={{
                    width: '100%',
                    padding: '12px 16px 12px 44px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    fontSize: '1rem',
                    color: '#495057',
                    transition: 'all 0.3s ease'
                  }}
                  placeholder="请输入手机号"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px',
                color: '#495057',
                fontWeight: '500'
              }}>
                密码
              </label>
              <div style={{ position: 'relative' }}>
                <FiLock style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
                <input
                  type="password"
                  name="password"
                  style={{
                    width: '100%',
                    padding: '12px 16px 12px 44px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    fontSize: '1rem',
                    color: '#495057',
                    transition: 'all 0.3s ease'
                  }}
                  placeholder="设置密码"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={6}
                />
              </div>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px',
                color: '#495057',
                fontWeight: '500'
              }}>
                确认密码
              </label>
              <div style={{ position: 'relative' }}>
                <FiLock style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
                <input
                  type="password"
                  name="confirmPassword"
                  style={{
                    width: '100%',
                    padding: '12px 16px 12px 44px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    fontSize: '1rem',
                    color: '#495057',
                    transition: 'all 0.3s ease'
                  }}
                  placeholder="确认密码"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <button 
              type="submit" 
              style={{
                width: '100%',
                padding: '14px 24px',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
              disabled={loading}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
            >
              {loading ? '创建账号中...' : (
                <>
                  <FiUserPlus /> 创建账号
                </>
              )}
            </button>
          </form>

          <div style={{ 
            marginTop: '24px',
            textAlign: 'center',
            color: '#6c757d'
          }}>
            已有账号？ <Link to="/login" style={{ 
              color: '#1976d2',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'color 0.3s ease'
            }}>
              登录
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterWithInvitation;
